import { useCallback, useEffect } from 'react';
import { useImmer } from 'use-immer';

export function useWaitForUpdate({
  maximumWaitTime,
  onFailed,
  onSuccess,
  predicate
}: {
  predicate: () => boolean;
  maximumWaitTime: number;
  onSuccess(): void;
  onFailed(): void;
}) {
  const [onSuccessState, setOnSuccessState] = useImmer<{ waiting: boolean; success: boolean; timedOut: boolean }>({
    success: false,
    waiting: false,
    timedOut: false
  });

  const onSuccessHandler = useCallback(() => {
    setOnSuccessState((draft) => {
      draft.waiting = true;
    });
    setTimeout(() => {
      setOnSuccessState((draft) => {
        draft.timedOut = true;
      });
    }, maximumWaitTime);
  }, [maximumWaitTime, setOnSuccessState]);

  useEffect(() => {
    if (onSuccessState.waiting === true && onSuccessState.success === true) {
      onSuccess();
    }
    if (onSuccessState.timedOut === true) {
      onFailed();
    }
  }, [onFailed, onSuccess, onSuccessState.success, onSuccessState.timedOut, onSuccessState.waiting]);

  useEffect(() => {
    if (predicate()) {
      setOnSuccessState((draft) => {
        draft.success = true;
      });
    }
  }, [predicate, setOnSuccessState]);

  return onSuccessHandler;
}
